import { Button } from "antd";
import { Download, Plus, RefreshCw, Zap } from "lucide-react";
import { FC } from "react";
import { useBooking } from "~/store";
import { useRefreshBookingData } from "~/services/booking/booking.mutations";

interface BookingHeaderProps {}

export const BookingHeader: FC<BookingHeaderProps> = () => {
  const { openBookingModal } = useBooking();
  const refreshBookingData = useRefreshBookingData();

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold uppercase tracking-wide text-[#1a1a2e]" style={{ fontFamily: "'Montserrat', sans-serif" }}>All Bookings</h1>
        <p className="text-sm text-[#999] uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>Manage and track all client bookings</p>
      </div>

      <div className="flex space-x-3">
        <Button
          icon={<RefreshCw size={16} />}
          onClick={refreshBookingData}
          className="flex items-center space-x-2"
          title="Refresh booking data"
        >
          Refresh
        </Button>
        <Button
          icon={<Download size={16} />}
          className="flex items-center space-x-2"
        >
          Export
        </Button>
        <Button
          icon={<Zap size={16} />}
          onClick={() => openBookingModal({ isEstimateMode: true })}
          className="flex items-center space-x-2 bg-green-50 border-green-500 text-green-700 hover:bg-green-100"
        >
          Quick Estimate
        </Button>
        <Button
          type="primary"
          icon={<Plus size={16} />}
          onClick={() => openBookingModal({})}
        >
          New Booking
        </Button>
      </div>
    </div>
  );
};